import React, { useState, useEffect } from "react";
import axios from "axios";
import swal from "sweetalert";
import { Link, useNavigate } from "react-router-dom";
import Crop from "../../components/admin/childComponents/appComponents/Crop";

const Sidebar = () => {
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;

  /* For Image Crop */
  const [returnCrop, setReturnCrop] = useState(null);
  const [cropImage, setCropImage] = useState("");
  const [closeModal, setCloseModal] = useState(false);

  const navigate = useNavigate("");

  //Fetches all Data
  const [generalData, setGeneralData] = useState({
    staffImage: null, //upload/admin_passports/6647bd6731088.png
    admin_type: null,
    adminId: null,
    menuSize: 0,
  });

  useEffect(() => {
    setGeneralData((prev) => ({
      ...prev,
      staffImage: localStorage.getItem("admin_passport"),
      admin_type: localStorage.getItem("admin_type"),
      adminId: localStorage.getItem("admin_id"),
    }));
  }, []);

  let image_02 = process.env.REACT_APP_BACKEND_URL + generalData.staffImage;

  const loadFile = function (event) {
    let myFileUrl = URL.createObjectURL(event.target.files[0]);

    setCropImage(myFileUrl);
    setCloseModal(true);
  };

  useEffect(() => {
    returnCrop && submitUpload();
  }, [returnCrop]);

  async function submitUpload() {
    let fileUploadItem;
    if (!returnCrop) {
      console.log("No file Selected");
      return swal(
        "Caution",
        "Please select a file or image to upload",
        "warning",
      );
    } else {
      fileUploadItem = returnCrop;
    }

    const formData = new FormData();
    formData.append("id", generalData.adminId);
    formData.append("uploadFile", fileUploadItem);
    formData.append("myFileUpdate", generalData.staffImage);
    formData.append("imagePath", "upload/admin_passports/");
    formData.append("dbName", "admindatas");
    formData.append("dbColume", "passport");

    await axios.get(`sanctum/csrf-cookie`).then((response) => {
      try {
        axios.post(BASE_URL + `cameras/item`, formData).then((res) => {
          if (res.data.status === 200) {
            localStorage.setItem("admin_passport", res.data.imagePath);
            setGeneralData((prev) => ({
              ...prev,
              staffImage: res.data.imagePath,
            }));

            swal("Success", res.data.message, "success");
          } else if (res.data.status === 500) {
            swal("Caution", res.data.message, "warning");
          } else {
            swal("Failed", res.data.message, "warning");
          }
        });
      } catch (error) {
        swal("Oops!", "Profile Image Update Failed", "error");
      }
    });
  }

  async function logoutSubmit(event) {
    event.preventDefault();

    await axios.get("sanctum/csrf-cookie").then((response) => {
      try {
        axios.post(BASE_URL + "logout").then((res) => {
          if (res.data.status === 200) {
            localStorage.removeItem("admin_passport");
            localStorage.removeItem("auth_token");
            localStorage.removeItem("admin_id");
            localStorage.removeItem("auth_name");
            localStorage.removeItem("admin_type");
            localStorage.removeItem("NumberType");
            localStorage.removeItem("debitGrandTotal");
            localStorage.removeItem("creditGrandTotal");
            localStorage.removeItem("admin_signature");
            localStorage.removeItem("newGrandTotal");
            localStorage.removeItem("grandTotal");
            localStorage.removeItem("admin_authority");
            localStorage.removeItem("admin_status");
            localStorage.removeItem("allGrandTotal");
            localStorage.removeItem("selectedSearch");
            localStorage.removeItem("bend");
            localStorage.removeItem("encryption");

            swal("Logout Successful", res.data.message, "success");
            navigate("/logout");
          } else {
            swal("Warning", res.data.message, "warning");
          }
        });
      } catch (error) {
        swal("Oops!", "Logout Failed", "error");
      }
    });

    setTimeout(function () {
      setGeneralData((prev) => ({
        ...prev,
        menuSize: 1,
      }));
    }, 3000);
  }

  return (
    <>
      <div>
        {closeModal ? (
          <Crop
            imageCropUrl={cropImage}
            setReturnCrop={setReturnCrop}
            aspectRatios={1}
            setCloseModal={setCloseModal}
          />
        ) : null}
      </div>
      {/* START SIDEBAR*/}
      <nav className="page-sidebar" id="sidebar">
        <div id="sidebar-collapse">
          <div className="admin-block">
            <div className="avatar-upload text-light d-flex my-4 text-light">
              <div className="col-md-4 m-0 p-0">
                <div className="avatar-edit admin-info">
                  <input
                    type="file"
                    id="imageUpload"
                    accept=".png, .jpg, .jpeg"
                    onChange={loadFile}
                  />
                  <label for="imageUpload"></label>
                </div>
                <div className="avatar-preview">
                  <img
                    loading="lazy"
                    decoding="async"
                    src={image_02}
                    alt={image_02 || "Image"}
                    id="imagePreview"
                    width="80px"
                    className="rounded-circle"
                  />
                </div>
              </div>
              <div class="admin-info">
                <div className="font-strong">
                  {localStorage.getItem("auth_name").substring(0, 12) + "..."}
                </div>
                <small>{generalData.admin_type}</small>
              </div>
            </div>
          </div>
          <ul className="side-menu metismenu">
            <li>
              <Link className="active" to="/user/dashboard">
                <i className="sidebar-item-icon fa fa-th-large" />
                <span className="nav-label">Dashboard</span>
              </Link>
            </li>
            <li
              className="heading bg-gradient fw-normal text-light"
              style={{ backgroundColor: "#415E78" }}
            >
              ATTENDANCE
            </li>
            <li>
              <Link to="/user/register">
                <i
                  className="sidebar-item-icon fa fa-file-text-o"
                  id="navbarDropdown"
                  data-bs-toggle="dropdown"
                />
                <span className="nav-label">
                  Staff Register
                  <div
                    className="badge bg-success rounded-1 float-end fw-normal text-light"
                    style={{ float: "right", marginRight: "7%" }}
                  >
                    1
                  </div>
                </span>
              </Link>
            </li>

            <li>
              <Link to="#">
                <i
                  className="sidebar-item-icon fa fa-file-text"
                  id="navbarDropdown"
                  data-bs-toggle="dropdown"
                />
                <span className="nav-label">
                  Reports
                  <div
                    className="badge bg-primary rounded-1 float-end fw-normal text-light"
                    style={{ float: "right", marginRight: "7%" }}
                  >
                    1
                  </div>
                </span>
                <i className="fa fa-angle-left arrow" />
              </Link>
              <ul className="nav-2-level" aria-labelledby="navbarDropdown">
                <li>
                  <Link to="/user/report">Payment Sheet</Link>
                </li>
              </ul>
            </li>

            <li
              className="heading bg-gradient fw-normal text-light"
              style={{ backgroundColor: "#415E78" }}
            >
              LOGOUT
            </li>

            <li>
              <Link to="#">
                <i
                  className="sidebar-item-icon fa fa-power-off"
                  id="navbarDropdown"
                  data-bs-toggle="dropdown"
                />
                <span className="nav-label">
                  Signout
                  <div
                    className="badge bg-danger rounded-1 float-end fw-normal text-light"
                    style={{ float: "right", marginRight: "7%" }}
                  >
                    1
                  </div>
                </span>
                <i className="fa fa-angle-left arrow" />
              </Link>
              <ul className="nav-2-level" aria-labelledby="navbarDropdown">
                <li>
                  <Link to="/admin/Users" onClick={logoutSubmit}>
                    Logout
                  </Link>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </nav>
      {/* END SIDEBAR*/}
    </>
  );
};
export default Sidebar;
